export enum LinkType {
    Principal = 1,
    Entity = 2,
    Company = 3,
}
